import * as yup from "yup";
import {
  fieldMaxLength,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";

export const tenantWizardFormSchema = yup
  .object({
    id: yup.number().required().defined(),
    firstName: yup
      .string()
      .required(requiredField("Име"))
      .trim()
      .max(200, fieldMaxLength("Име", 200))
      .defined(),
    lastName: yup
      .string()
      .required(requiredField("Фамилия"))
      .trim()
      .max(200, fieldMaxLength("Фамилия", 200))
      .defined(),
    phoneNumber: yup
      .string()
      .required(requiredField("Телефонен номер"))
      .trim()
      .max(200, fieldMaxLength("Телефонен номер", 200))
      .defined(),
    email: yup
      .string()
      .email('Полето "Имейл" не е валидно')
      .required(requiredField("Имейл"))
      .trim()
      .max(200, fieldMaxLength("Имейл", 200))
      .defined(),
    termsOfUse: yup.string().nullable().defined(),
    policyLastModified: yup.date().nullable().defined(),
  })
  .required();

export type ITenantWizardFormModel = yup.InferType<
  typeof tenantWizardFormSchema
>;

export const tenantWizardFormDefaultValues: ITenantWizardFormModel = {
  id: 0,
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  termsOfUse: "",
  policyLastModified: null,
};
